import React, { Component }  from 'react';
const Spinner = () => <div className="loader"></div>;

export default Spinner;